import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.96 11h2.97a8.012 8.012 0 0 1-5.252 6.53c1.025-1.465 2.078-3.635 2.282-6.53zm-9.92 0c.204 2.895 1.258 5.065 2.283 6.53A8.01 8.01 0 0 1 2.07 11h2.97zm0-2H2.07a8.01 8.01 0 0 1 5.253-6.53C6.298 3.934 5.243 6.104 5.04 9zm2.002 0C7.328 5.506 9.059 3.302 10 2.346c.94.956 2.672 3.161 2.959 6.654H7.042zm0 2h5.917c-.286 3.494-2.02 5.7-2.96 6.653-.94-.956-2.671-3.16-2.957-6.653zm7.899-2c-.206-2.895-1.243-5.073-2.267-6.53A8.011 8.011 0 0 1 17.93 9h-2.99zM0 10c0 5.513 4.486 10 10 10s10-4.487 10-10c0-5.514-4.486-10-10-10S0 4.486 0 10z"
});

var SvgGlobeMajorMonotone = function SvgGlobeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgGlobeMajorMonotone as S };
